import React from 'react'
import AppStore from './app.store'

interface RootStore {
  appStore: AppStore
}

class RootStore {
  constructor() {
    this.appStore = new AppStore(this)
  }
}

const store = new RootStore()
const StoreContext = React.createContext(store)

export const useStores = () => React.useContext(StoreContext)
export default store